import * as Sentry from "@sentry/react";

const style = [
  "background: #011D28",
  "border-left: 1px solid #02908C",
  "border-right: 1px solid #02908C",
  "color: rgb(219, 231, 219)",
  "padding: 4px 8px",
  "font-size: 14px",
  "line-height: 20px",
].join(";");

const groupStyle = [
  "background: rgba(10, 166, 28, 0.15)",
  "border-left: 1px solid #0AA61D",
  "border-right: 1px solid #0AA61D",
  "color: rgb(219, 231, 219)",
  "padding: 4px 8px",
  "font-size: 14px",
  "line-height: 20px",
].join(";");

const errorStyle = [
  "background: rgba(149, 51, 33, 0.15)",
  "border-right: 1px solid #953321",
  "border-left: 1px solid #953321",
  "color: rgb(219, 231, 219)",
  "padding: 4px 8px",
  "font-size: 14px",
  "line-height: 20px",
].join(";");

/** @deprecated - use {@link captureException} instead */
export class Logger {
  /** @deprecated - no replacement, use {@link captureException} if you need to log an error */
  static log(message: string, data?: unknown): void {
    if (process.env.NODE_ENV === "production") {
      Sentry.captureException(data, { level: "log" });
    }
    if (process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test") {
      if (data) {
        console.group(`%c ⊳ ${message} ↴`, groupStyle);
        console.table(data);
        console.groupEnd();
      } else {
        console.log(`%c ${message}`, style);
      }
    }
  }

  /** @deprecated - no replacement, use {@link captureException} if you need to log an error */
  static warning(data: unknown): void {
    if (process.env.NODE_ENV === "production") {
      Sentry.captureException(data, { level: "warning" });
    }
    if (process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test") {
      console.warn(`%c ${data}`, errorStyle);
    }
  }

  /** @deprecated - use {@link captureException} instead */
  static error(data: unknown, options?: Record<string, unknown>): void {
    if (process.env.NODE_ENV === "production") {
      Sentry.captureException(data, {
        level: "error",
        ...options,
      });
    }
    if (process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test") {
      console.log(`%c ${data}`, errorStyle);
    }
  }

  /** @deprecated - no replacement, use {@link captureException} if you need to log an error  */
  static trace(error: unknown): void {
    if (process.env.NODE_ENV !== "production") {
      console.trace(`%c ${error}`, errorStyle);
    }
  }
}
